webpackJsonp([138746315915673],{

/***/ 528:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Mihail Eric","subtitle":"Engineer, researcher, educator.","copyright":"Copyright","menu":[{"label":"Blog","path":"/blog/"},{"label":"Projects","path":"/projects/"},{"label":"Teaching","path":"/teaching/"}],"author":{"name":"Mihail Eric","email":"mihail911@gmail.com","twitter":"mihail_eric","github":"mihail911","linkedin":"mihaileric"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/posts/united-states-financial-regulatory-system/","tagSlugs":["/tags/fintech/","/tags/business/","/tags/regulation/"]},"frontmatter":{"title":"Overview of the United States Financial Regulatory Ecosystem","date":"2021-10-04T23:40:37.121","description":"I describe the motivation, organization, and main agencies of the US financial regulatory system, including their history and what their various responsibilities are.","tags":["Fintech","Business","Regulation"]}}}]}},"pathContext":{"tag":"Fintech"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-fintech-5195ef233b93d2d6ac10.js